import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { CartService } from "src/app/core/services/cart.service";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";

import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { OrderService } from "src/app/core/services/order.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/core/services/user.service";
import { table } from "console";

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.css"],
})
export class CheckoutComponent implements OnInit {

  codRestaurante: string = '';
  codMesa: string = '';
  scanUrl: string;
  
  datosUsuario: boolean = true;
  formaPago: boolean = false;
  ordenFinalizada: boolean = false;
  closeResult = "";
  viewProgress: boolean = true;
  loadingCard: boolean = false;
  total: number = 0;
  formUser: FormGroup;
  formCard: FormGroup;
  formCheck: FormGroup;

  loading: boolean = false;
  modalReference: NgbModalRef;
  cliente: any;
  paymentMethod = "ef";
  months: string[];
  years: number[];
  emailPattern: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  numberPattern: any = "[0-9]+";
  iframediv: boolean = false;
  loadingPay: boolean = false;
  ordenEnviada: boolean = false;
  pagoProceso:boolean=false;
  constructor(
    private cartService: CartService,
    private userService: UserService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private orderService: OrderService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.formUser = this.createFormGroup();
    this.formCard = this.createFormGroupCard();
    this.formCheck = this.createFormGroupCheck();

    this.months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    let date = new Date();
    let year = parseInt(date.getFullYear().toString().substr(2, 2));
    this.years = new Array();
    for (let index = year; index < year + 15; index++) {
      this.years.push(index);
    }
  }

  @ViewChild('iframe', {
    static: false
  }) iframe: ElementRef;

  async ngOnInit() {
    const rest = localStorage.getItem('codRestaurante') || '10';
    const mesa = localStorage.getItem('codMesa') || '8';

    // Por si los valores vienen con comillas dobles, las quitamos con replace:
    this.codRestaurante = rest.replace(/"/g, '');
    this.codMesa = mesa.replace(/"/g, '');

    // Construimos la URL tal cual queremos que aparezca:
    this.scanUrl = '/scan/' + this.codRestaurante + '&' + this.codMesa;
    // ==> "/scan/10&8"

    this.orderService.validateSession();
    await this.orderAvaliable();
    const enviar = this.route.snapshot.params.enviar;
    let client = this.userService.getClient();
    if (client) {
      if (client.name && client.tel && client.email) {
        this.next();
      }
    }
    this.total = this.cartService.getTotal();
    if (enviar) {
      if (enviar === "1") {
        this.finishOrder();
        return;
      }
    }
    //this.toastrService.info('Funcion aun no disponible, puedes seguir agregando productos a tu orden');
    //return;
    this.setPaymentMethod('tj');

  }

  async orderAvaliable() {
    
    if (this.orderService.getOrderNumberSession() > 0) {
      this.loading=true;
      let status = await this.orderService.getOrderAvailable();
      if (!status) {
        this.toastrService.info("La orden ya fue facturada");
        this.router.navigate(["/inicio"]);
        this.cartService.clearCart();
        return;
      }

      let order = await this.orderService.getOrdenMesa();
      this.orderService.updateOrder(order[0]);
      this.total = this.cartService.getTotal();
      this.loading=false;
    }
  }

  createFormGroupCheck() {
    return new FormGroup({
      termino: new FormControl(
        false,
        Validators.required
      )
    });
  }

  createFormGroup() {
    let client = this.userService.getClient();
    return new FormGroup({
      name: new FormControl(
        client != null ? client.name : "",
        Validators.required
      ),
      tel: new FormControl(client != null ? client.tel : "", [
        Validators.required,
        Validators.pattern(this.numberPattern),
        Validators.maxLength(8),
        Validators.minLength(8),
      ]),
      email: new FormControl(
        client != null ? client.email : "",
        Validators.pattern(this.emailPattern)
      ),
      address: new FormControl(client != null ? client.address : "", Validators.required), // Agregado
      rtn: new FormControl(
        client != null ? client.rtn : "",
        Validators.pattern(this.numberPattern)
      ),
    });
  }
  open(content) {
    this.modalReference = this.modalService.open(content);
    this.modalReference.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  createFormGroupCard() {
    let card = this.userService.getCard();
    return new FormGroup({
      holder: new FormControl(card != null ? card.holder : "", [
        Validators.required,
        Validators.minLength(5),
      ]),
      cardNumber: new FormControl(card != null ? card.cardNumber : "", [
        Validators.required,
        Validators.pattern(this.numberPattern),
        Validators.maxLength(16),
        Validators.minLength(15),
      ]),
      month: new FormControl(card != null ? card.month : "Mes", [
        Validators.required,
        Validators.pattern(this.numberPattern),
      ]),
      year: new FormControl(card != null ? card.year : "Año", [
        Validators.required,
        Validators.pattern(this.numberPattern),
      ]),
      ccv: new FormControl(card != null ? card.ccv : "", [
        Validators.required,
        Validators.pattern(this.numberPattern),
        Validators.maxLength(4),
        Validators.minLength(3),
      ]),
    });
  }

  get name() {
    return this.formUser.get("name");
  }
  get address() {
    return this.formUser.get("address");
  }
  get tel() {
    return this.formUser.get("tel");
  }
  get email() {
    return this.formUser.get("email");
  }
  get rtn() {
    return this.formUser.get("rtn");
  }

  get termino() {
    return this.formCheck.get("termino");
  }

  get holder() {
    return this.formCard.get("holder");
  }
  get cardNumber() {
    return this.formCard.get("cardNumber");
  }
  get month() {
    return this.formCard.get("month");
  }
  get year() {
    return this.formCard.get("year");
  }
  get ccv() {
    return this.formCard.get("ccv");
  }

  async next() {
    if (this.formUser.valid) {
      this.datosUsuario = false;
      this.formaPago = true;
      this.userService.setClient(this.getUserForm());
      window.scrollTo(0, 0);
      await this.orderAvaliable();
    } else {
      this.toastrService.warning(
        "Revisa los datos que ingresaste, e intenta nuevamente",
        "Datos no validos"
      );
    }
  }

  getUserForm(): any {
    return {
      name: this.formUser.get("name").value,
      address: this.formUser.get("address").value,
      tel: this.formUser.get("tel").value,
      email: this.formUser.get("email").value,
      rtn: this.formUser.get("rtn").value,
    };
  }

  getCardForm(): any {
    return {
      holder: this.formCard.get("holder").value,
      cardNumber: this.formCard.get("cardNumber").value,
      month: this.formCard.get("month").value,
      year: this.formCard.get("year").value,
      ccv: this.formCard.get("ccv").value,
    };
  }

  previous() {

    if (this.datosUsuario == true && !this.ordenFinalizada) {
      this.router.navigate(["/carrito"]);
    } else if (this.ordenFinalizada) {
      this.router.navigate(["/inicio"]);
    }
    else {
      this.datosUsuario = true;
      this.formaPago = false;
      window.scrollTo(0, 0);
    }
  }

  setPaymentMethod(method: string) {
    this.paymentMethod = method;
  }

  async finishOrder() {
    this.loading = true;
    this.datosUsuario = false;
    let name = this.formUser.get("name").value;
    let address = this.formUser.get("address").value;
    let tel = this.formUser.get("tel").value;
    let rtn = this.formUser.get("rtn").value;
    let email = this.formUser.get("email").value;
    let termino = this.formCheck.get("termino").value;

    if (!this.cartService.validateNewProducts() && this.paymentMethod != 'tj') {
      this.toastrService.info("No hay productos nuevos para enviar");
      this.router.navigate(["/inicio"]);
    }

    let order: any = await this.orderService.getOrder(
      name, 
      address,
      tel,
      rtn,
      email,
      this.total,
      this.paymentMethod
    );

    let status = await this.orderService.getOrderAvailable();
    if (!status) {
      this.toastrService.info("La orden ya fue facturada");
      this.router.navigate(["/inicio"]);
      this.cartService.clearCart();
      return false;
    }
    let alert = false;
    if (this.paymentMethod == "tj" && this.formCard.valid) {
      if (email == "") {
        this.loading = false;
        this.previous();
        this.toastrService.warning(
          "Debes ingresar un correo electronico para tus pagos con tarjeta"
        );
        return false;
      }
      if (termino == false) {
        this.loading = false;
        this.toastrService.warning(
          "Debes aceptar los terminos y condiciones"
        );
        return false;
      }
      await this.payCreditCard(order);
    }

    if (this.paymentMethod == "ef") {
      this.loading = true;
      let response: boolean = await this.orderService.finishOrder(order);
      this.cartService.shippedProduct();
      this.loading = false;
      this.datosUsuario = false;
      this.formaPago = false;
      this.ordenEnviada = true;
      this.viewProgress = false;
      window.scrollTo(0, 0);
    }
  }

  ultimosNumerosTarjeta(numeroTarjeta: string) {
    return numeroTarjeta.length == 15 ? numeroTarjeta.substring(12, 15) : numeroTarjeta.substring(12, 16);
  }

  marcarTarjeta(numeroTarjeta: string): string {
    if (parseInt(numeroTarjeta.substring(0, 1)) == 4) {
      return "VISA";
    }
    if (parseInt(numeroTarjeta.substring(0, 1)) == 5) {
      return "MASTERCARD";
    }
    if (parseInt(numeroTarjeta.substring(0, 1)) == 3) {
      return "AMEX";
    }
    return "";
  }

  async payCreditCard(order: any) {
    this.pagoProceso=true;
    let numeroTarjeta = this.formCard.get('cardNumber').value;
    let temp = this.ultimosNumerosTarjeta(numeroTarjeta);
    let numeroTarjetaMask = "XXXXXXXXXXXX" + temp;
    let marca = this.marcarTarjeta(numeroTarjeta);
    let paymentComplete = await this.orderService.payCardCreditOrder(
      order.codOrden,
      this.total,
      this.formCard.get("cardNumber").value,
      numeroTarjetaMask,
      this.formCard.get("month").value,
      this.formCard.get("year").value,
      this.formCard.get("ccv").value,
      this.formCard.get("holder").value,
      order
    );
    if (!paymentComplete.RedirectData) {
      this.toastrService.error(
        'El pago fue rechazado, favor revisalos e intenta nuevamente',
        'Pago rechazado'
      );
      this.loadingCard = false;
      
      this.iframediv = false;
      this.loading = false;
      return false;
    }
    this.iframediv = true;
    this.loadingPay = true;
    let content = paymentComplete.RedirectData.toString();
    let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
    doc.open();
    doc.write(content);
    doc.close();
    this.formaPago = false;
    this.viewProgress = false;
    this.loading = false;
    return false;
  }

  @HostListener('window:message', ['$event'])
  async onMessage(e) {
    if (e.origin == 'https://2mnu.com') {
      console.log(e);
      const data = e.data;
      this.loadingPay = false;
      if (data.Approved == "true") {
        let name = this.formUser.get("name").value;
        let address = this.formUser.get("address").value;
        let tel = this.formUser.get("tel").value;
        let rtn = this.formUser.get("rtn").value;
        let email = this.formUser.get("email").value;
        let termino = this.formCheck.get("termino").value;
        let order: any = await this.orderService.getOrder(
          name,
          address,
          tel,
          rtn,
          email,
          this.total,
          this.paymentMethod
        );
        let response: boolean = await this.orderService.finishOrder(order);
        this.datosUsuario = false;
        this.formaPago = false;
        this.loadingCard = false;
        this.ordenFinalizada = true;
        this.viewProgress = false;
        this.iframediv = false;
        window.scrollTo(0, 0);
        this.orderService.clearQR();
        this.cartService.clearCart();
      }else{
        this.pagoProceso=true;
      }

    }
  }

}
